export const initialState = {
  urlData: [],
  pdfData: [],
  cacheTextQna: [],
  cacheMutualFund: [],
  cacheGreeting: [],
  cacheBingQna: [],
  alertModalOpen: false,
  activeTab: "ABCD App",
  ctaLinks: [],
  promptsList: [],
  logsData: [],
  errorLogsData: []
};
